// extracted by mini-css-extract-plugin
module.exports = {"main-container":"Signup_main-container__2vhXD"};